













































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { State, StateService } from '@/services/StateService';

@Component({
	components: {},
})
export default class LocationListFilterState extends Vue {
	@Prop({}) state!: Array<string>;

	mounted() {
		(new StateService()).findAll().then((value) => {
			this.listOfAllStates = value;
		});
	}
	
	numberOfChips = 2;
	
	listOfAllStates: Array<State> = [];

	// selectedStates: Array<string> = [];

	set selected(list: Array<string>) {
		// this.selectedStates = list;
		this.$emit('updatestate', list);
	}
	get selected(): Array<string> {
		return this.state;
	}

	doSelectAll() {
		if (this.state.length) {
			this.$emit('updatestate', []);
			return;
		}

		const state = this.listOfAllStates.map((option) => {
			return option.code;
		});
		this.$emit('updatestate', state);
	}

	get selectAllIcon() {
		// checked
		if (this.state.length === this.listOfAllStates.length) {
			return 'fas fa-check-square';
		}

		// partially checked
		if (this.state.length > 0) {
			return 'fas fa-minus-square';
		}

		// unchecked
		return 'far fa-square';
	}

	get selectAllColor() {
		// checked
		if (this.state.length === this.listOfAllStates.length) {
			return 'indigo darken-4';
		}

		// partially checked
		if (this.state.length > 0) {
			return 'indigo darken-4';
		}

		// unchecked
		return 'grey';
	}
	
}
